import axios from "axios";
import Swal from "sweetalert2";
import { getCookie } from "cookies-next";
import { Alert } from "bootstrap";

const nodeEnvironment = process.env.REACT_APP_NODE_ENV;
// const developmentURL = "http://localhost:3017";
const serverUrl = process.env.REACT_APP_NODE_URL;
// const serverUrl = "http://192.168.1.6:3017";
// const machine_IP = "http://192.168.29.169:3016";
// const physical_server_IP = "http://192.168.29.197:3016";

export function getServerUrl() {
  // if (nodeEnvironment === "development") {
  //   return developmentURL;
  // }

  // if (nodeEnvironment === "physical_server") {
  //   return physical_server_IP;
  // }

  // if (nodeEnvironment === "machine_IP") {
  //   return serverUrl;
  // }

  // if (nodeEnvironment === "server") {
  //   return serverUrl;
  // }

  return serverUrl;
}
export const communication = {
  //  =====================login apis intergrated=========================

  login: async function (data) {
    try {
      return axios.post(`${getServerUrl()}/application/userLogin`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  ///////////////////////////==============form start
  getApplicationList: async function (page = 1, searchString) {
    try {
      return axios.post(
        `${getServerUrl()}/application/getAllIncubationForm`,
        { page, searchString },
        {
          headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getuserById: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/application/getIncubationFormById`,
        { _id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  exportStudentDetails: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/application/export-user-incubation-forms`, { id: id }, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("userToken")}`,
        },
      }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  deleteUser: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/application/deleteIncubationForm`,
        { _id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  updateUserStatus: async function (data) {
    try {
      return await axios.post(
        `${getServerUrl()}/application/accept-reject-incubation-form`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  ///////////////////////////==============form end 

  ///////////////////////////==============annoucemnet start 

  getAnnouncementList: async function (page = 1, searchString) {
    try {
      return axios.get(
        `${getServerUrl()}/application/getAnnouncementList?page=${page}&searchString=${searchString}`,
        {
          headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  getAnnouncementById: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/application/getAnnouncementById`,
        { _id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  createAnnouncement: async function (dataToSend) {
    console.log("dataToSend", dataToSend);

    try {
      return axios.post(`${getServerUrl()}/application/createAnnouncement`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("userToken")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  updateAnnouncement: async function (dataToSend) {
    console.log("dataToSend", dataToSend);

    try {
      return axios.post(`${getServerUrl()}/application/updateAnnouncemet`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("userToken")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  deleteAnnouncemnet: async function (id) {
    console.log("deleteAnnouncementById", id);

    try {
      return axios.post(
        `${getServerUrl()}/application/deleteAnnouncementById`,
        { _id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  ///////////////////////////==============annoucemnet done 
  ///////////////////////////==============annoucemnet done 
  ///////////////////////////==============annoucemnet done 
  ///////////////////////////==============annoucemnet done 
  ///////////////////////////==============annoucemnet done 
  sendLoginOtp: async function (mobile) {
    try {
      return axios.post(`${getServerUrl()}/user/send-login-otp`,
        { mobile },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  verifyLoginOtp: async function (mobile, otp) {
    try {
      return axios.post(
        `${getServerUrl()}/user/verify-login-otp`,
        { mobile, otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  logout: async function () {
    try {
      return axios.get(`${getServerUrl()}/user/logout`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  sendUserRegistrationOtp: async function (mobile, userType) {
    try {
      return axios.post(
        `${getServerUrl()}/user/send-user-registration-otp`,
        { mobile, userType },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  verifyOtp: async function (mobile, otp) {
    try {
      return axios.post(
        `${getServerUrl()}/user/verify-register-user-otp`,
        { mobile, otp },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  updateProfile: async function (isFileAttached, formData) {
    try {
      return axios.post(
        `${getServerUrl()}/user/update-profile?isFileAttached=${isFileAttached}`,
        formData,
        {
          headers: {
            "Content-Type": isFileAttached ? "multipart/form-data" : "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  //  =====================user management apis intergrated=========================
  getUserList: async function (page = 1, searchString) {
    try {
      return axios.post(
        `${getServerUrl()}/user/get-user-list`,
        { searchString, page },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("userToken")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  // getuserById: async function (id) {
  //   try {
  //     return axios.post(
  //       `${getServerUrl()}/user/get-user-by-id`,
  //       { id },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${getCookie("blueLadder")}`,
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     Swal.fire({ text: error.message, icon: "warning" });
  //   }
  // },
  addUser: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/create-user`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  updateUser: async function (dataToUpdate) {
    try {
      return axios.post(`${getServerUrl()}/user/update-user`, dataToUpdate, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  changeUserStatus: async function (userId, status) {
    try {
      return axios.post(
        `${getServerUrl()}/user/change-user-status`,
        { userId, status },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  //  =====================project management apis intergrated=========================

  getProjectList: async function (page = 1, searchString) {
    try {
      return axios.post(
        `${getServerUrl()}/project/get-project-list`,
        { searchString, page },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getActiveUserList: async function () {
    try {
      return axios.get(`${getServerUrl()}/user/get-active-user`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getMilestoneList: async function (data) {
    try {
      return axios.post(`${getServerUrl()}/project/get-project-wise-milestone`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  addProject: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/project/create-project`, dataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getProjectDetailsById: async function (projectId) {
    try {
      return axios.post(
        `${getServerUrl()}/project/get-project-by-id`,
        { projectId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  updateProject: async function (isFileAttached, formData) {
    try {
      return axios.post(
        `${getServerUrl()}/project/update-project?isFileAttached=${isFileAttached}`,
        formData,
        {
          headers: {
            // "Content-Type": "application/json",
            "Content-Type": isFileAttached ? "multipart/form-data" : "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
          // responseType: "blob",
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  changeProjectStatus: async function (projectId, status) {
    try {
      return axios.post(
        `${getServerUrl()}/project/change-project-status`,
        { projectId, status },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getProjectWiseMilestone: async function (projectId) {
    try {
      return axios.post(
        `${getServerUrl()}/project/get-project-wise-milestone`,
        { projectId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  updateMilestone: (formData) => {
    try {
      return axios.post(`${getServerUrl()}/project/upload-daily-update-of-milestone`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  //  =====================Notifications=========================
  getNotifications: async function (page = 1, searchString) {
    try {
      return axios.post(
        `${getServerUrl()}/notification/get-all-notification`,
        { page, searchString },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getNotificationCount: async () => {
    try {
      return axios.get(`${getServerUrl()}/notification/get-notification-count`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Alert.alert(error?.message);
    }
  },
  deleteNotifications: async function (notificationId) {
    try {
      return axios.post(
        `${getServerUrl()}/notification/delete-notification`,
        { notificationId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  deleteAllNotifications: async function () {
    try {
      return axios.get(`${getServerUrl()}/notification/delete-all-notification`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  //  =====================Complaint section apis intergrated=========================

  getComplaintList: async function (data) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/get-complaint-list`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  raiseComplaint: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/complaint/raise-complaint`, dataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  getActiveProjectsToRaiseComplaint: async function () {
    try {
      return axios.get(`${getServerUrl()}/project/get-active-project`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("blueLadder")}`,
        },
      });
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  changeComplaintStatus: async function (complaintId) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/change-complaint-status`,
        { complaintId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  //==================Complaint Chat-Bot====================
  getComplaintById: async function (complaintId) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/get-complaint-by-id`,
        { complaintId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  replyToComplaint: async function (isFileAttached, formData) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/reply-to-complaint?isFileAttached=${isFileAttached}`,
        formData,
        {
          headers: {
            "Content-Type": isFileAttached ? "multipart/form-data" : "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },

  closeComplaint: async function (isFileAttached, formData) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/close-complaint?isFileAttached=${isFileAttached}`,
        formData,
        {
          headers: {
            "Content-Type": isFileAttached ? "multipart/form-data" : "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
  reOpenComplaint: async function (formData) {
    try {
      return axios.post(
        `${getServerUrl()}/complaint/reopen-complaint`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("blueLadder")}`,
          },
        }
      );
    } catch (error) {
      Swal.fire({ text: error.message, icon: "warning" });
    }
  },
};
